import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import BannerImg from '../assets/bannerNumbers.svg';
import BannerBase from '../assets/bannerBase.webp';
import BannerPillRock1 from '../assets/bannerPillRock1.webp';
import BannerPillRock2 from '../assets/bannerPillRock2.webp';
import ArrowUp from '../assets/arrowUp.svg';

const CHROME_STORE_URL =
  'https://chromewebstore.google.com/detail/cero-linkedin-personal-br/moeocagahkkomhnekdhlfjbmomkjoddj?hl=en';

const CARD_COUNT = 9;

export const BannerSection: React.FC = () => {
  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center banner-section"
      style={{ paddingTop: 80, paddingBottom: 80 }}
    >
      <Row className="w-100 justify-content-center">
        <Col xs={12} className="d-flex flex-column align-items-center">
          <div className="banner-section__desktop" style={{ width: '80%' }}>
            <a
              href={CHROME_STORE_URL}
              className="banner-section__desktop-banner"
              aria-label="Get started with Cero"
            >
              <Image
                src={BannerImg}
                alt="Numbers don't lie — so we use Data Science to drive calculated growth"
                className="banner-section__desktop-banner-img"
              />
            </a>
          </div>

          <div className="banner-section__mobile">
            <div className="banner-section__mobile-card">
              <div className="banner-section__mobile-base" aria-hidden="true">
                <img src={BannerBase} alt="" className="banner-section__mobile-base-img" />
              </div>

              <div className="banner-section__mobile-overlay" aria-hidden="true" />

              <div className="banner-section__mobile-cards" aria-hidden="true">
                {Array.from({ length: CARD_COUNT }, (_, index) => (
                  <div key={index} className="banner-section__mobile-card-item" />
                ))}
              </div>

              <div className="banner-section__mobile-content">
                <h2 className="banner-section__mobile-headline">
                  <span className="banner-section__mobile-line">Numbers don&apos;t lie</span>
                  <span className="banner-section__mobile-line banner-section__mobile-line--inline">
                    so we use Data
                    <span
                      className="banner-section__mobile-pill"
                      style={{ backgroundImage: `url(${BannerPillRock1})` }}
                    />
                  </span>
                  <span className="banner-section__mobile-line banner-section__mobile-line--inline">
                    <span
                      className="banner-section__mobile-pill"
                      style={{ backgroundImage: `url(${BannerPillRock2})` }}
                    />
                    Science to drive
                  </span>
                  <span className="banner-section__mobile-line banner-section__mobile-line--accent">
                    calculated growth
                  </span>
                </h2>

                <a
                  href={CHROME_STORE_URL}
                  className="banner-section__mobile-cta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Get Started for free</span>
                  <Image src={ArrowUp} alt="" className="banner-section__mobile-cta-icon" />
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
